import GuestMiddleware from "@/middlewares/GuestMiddleware";

export default [
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/guest/Login.vue"),
  },
  {
    path: "/forgot-password",
    name: "ResetPasswordRequest",
    component: () =>
      import(
        /* webpackChunkName: "resetPasswordRequest" */ "@/views/guest/ResetPasswordRequest.vue"
      ),
  },
  {
    path: "/reset-password",
    name: "ResetPasswordChange",
    component: () =>
      import(
        /* webpackChunkName: "resetPasswordChange" */ "@/views/guest/ResetPasswordChange.vue"
      ),
  },
  {
    path: "/2fa",
    name: "TwoFactorAuth",
    component: () =>
      import(
        /* webpackChunkName: "twoFactorAuth" */ "@/views/guest/TwoFactorAuth.vue"
      ),
  },
];
